import{parseStyleObject as t}from"./parseStyleObject.min.mjs";import{parseStyleString as r}from"./parseStyleString.min.mjs";function e(e){const i={},m=e.getAttribute("style");return m?("string"==typeof m?r(m,i):t(m,i),i):i}export{e as parseStyleAttribute};
//# sourceMappingURL=parseStyleAttribute.min.mjs.map
